var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJackpotStarSilverDesktopIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 186,
    viewBox: "0 0 193 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.223 13.069L126.217 41.5503C129.515 48.2605 135.899 52.9136 143.287 53.9842L174.634 58.5266C189.109 60.6242 194.91 78.4844 184.411 88.7312L161.726 110.872C156.376 116.094 153.939 123.623 155.208 130.998L160.611 162.39C163.104 176.874 147.951 187.893 135.017 181.066L106.949 166.249C100.347 162.764 92.4568 162.764 85.8551 166.249L57.787 181.066C44.8531 187.893 29.6994 176.874 32.1926 162.39L37.596 130.998C38.8653 123.623 36.4281 116.094 31.0778 110.872L8.39262 88.7312C-2.10625 78.4844 3.69526 60.6242 18.1702 58.5266L49.5164 53.9842C56.9049 52.9136 63.2892 48.2605 66.5863 41.5503L80.5812 13.069C87.0491 -0.0941287 105.755 -0.0941282 112.223 13.069Z",
    fill: "url(#paint0_linear_1025_8297)",
    stroke: "url(#paint1_linear_1025_8297)",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1025_8297",
    x1: 95.8415,
    y1: 26.0534,
    x2: 98.0293,
    y2: 179.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291665,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221875,
    stopColor: "#747474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378125,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378225,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461458,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690625,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872917,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989898"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1025_8297",
    x1: 120.834,
    y1: 2.76597,
    x2: 110.121,
    y2: 184.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7EAF1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJackpotStarSilverDesktopIcon);
export default __webpack_public_path__ + "static/media/jackpot_star_silver_desktop_icon.2707c6a8e844c548e230e97034b0e912.svg";
export { ForwardRef as ReactComponent };